import ChannelListUpgradablePlanPriceContainer from '@components/atoms/container/channelListUpgradablePlanPriceContainer';
import ChannelListUpgradablePlanText from '@components/atoms/text/channelListPlanPriceText';
import ChannelListUpgradablePlanPrice from '@components/atoms/text/channelListPlanPrice';
import ChannelListPlanSmallPrice from '@components/atoms/text/channelListPlanSmallPrice';
import TranslationManager from '@shared/assets/locale/translationsManager';

interface Props {
  price: number;
}

/**
 * Extracts the decimal portion from a number.
 *
 * @param {number} number - The number to extract decimals from
 * @returns {number} The decimal portion as a number (e.g., 0.99 from 9.99)
 */
export function getDecimal(number: number) {
  return parseFloat(number.toString().split('.')[1]);
}

/**
 * Component that displays a plan price with formatted decimal and currency.
 * Shows the price split into integer and decimal parts with "€" symbol.
 *
 * @param {Props} props - Component props containing the price value
 * @returns {JSX.Element} Formatted price display component
 */
export default function ChannelListPlanPrice({ price }: Props) {
  const number = Math.trunc(price);
  const decimals = getDecimal(price);
  return (
    <ChannelListUpgradablePlanPriceContainer
      id={'channelListPlanPriceContainer'}
    >
      <ChannelListUpgradablePlanText>
        {TranslationManager.get('PAGES.CHANNEL_LIST.PRICE.ONLY')}
      </ChannelListUpgradablePlanText>
      <ChannelListUpgradablePlanPrice>
        {number}
        <ChannelListPlanSmallPrice id={'decimals'}>
          {decimals ? `,${decimals}` : ''}
          {'€'}
        </ChannelListPlanSmallPrice>
      </ChannelListUpgradablePlanPrice>
      <ChannelListUpgradablePlanText>
        {TranslationManager.get('PAGES.CHANNEL_LIST.PRICE.MONTHLY')}
      </ChannelListUpgradablePlanText>
    </ChannelListUpgradablePlanPriceContainer>
  );
}
